module.exports = __webpack_public_path__ + "img/icon-arrow-right-chev.f95942d5.svg";